 jQuery(function(){

console.log("working");
 
    
    $( "input" ).delegate( "#checkout_option", "click", function() {
  e.preventDefault();
  console.log("working");
});
  
  });


function updateCart(){
  
  
var apiURL ="https://8090f286.ngrok.io";
  
    var getProducts =  localStorage.getItem("products") ; 
  	if(getProducts != null){
  	 	if(getProducts.length > 0){
  			getProducts = JSON.parse(atob(getProducts));    
    		var getProductData = localStorage.getItem("productData"); 
          	if(getProductData != null){
      			getProductData = JSON.parse(atob(getProductData));
       
                var get_product_id = getProductData.product_id;
                var get_product_handle = getProductData.product_handle;
                var get_variant_id = getProductData.variant_id;

                if(get_product_id != null  ){    
  					  
                  
                  /* IF no-checkout product is not in cart then it adds it*/
      				jQuery.getJSON('/cart.js', function(cart) {
 
                    	let items = cart.items;       	
                        var j=0;
                        for(var i=0; i < items.length; i++){
                          /*Match Local Storage Product ID with Cart Items */
                           if(items[i].variant_id == get_variant_id){ j =1;break;}
                        }
                        if(j == 0){
                          
                           var variant_id = get_variant_id;
                          var update = {};
                          update[variant_id] = 1;

                          jQuery.post('/cart/update.js', {
                            updates: update
                          }).always(function (e) {
                             

                          });

                        }        				
  
					} ); /* ENDs JSON */
                  
                  jQuery.each(getProducts, function( index, value ) {
  								console.log( index + ": " + value.variant_id );
					});
                  
                  
                }
    		  if(get_product_id == null   ){
                  var data = localStorage.getItem("products");
                   console.log("getProducts no NULL",data);
                 $.post(apiURL+"/update-product.php",{data:data},function(response){

                    var responseData = JSON.parse(atob(response));
                    var resProductData = btoa(JSON.stringify(responseData.productData));
                     localStorage.setItem("productData",resProductData);


                  });
            
   	 			}
    		}
    if( getProductData == null){
    	 var data = localStorage.getItem("products");
       console.log("getProducts NULL",data);
     $.post(apiURL+"/update-product.php",{data:data},function(response){
        
        var responseData = JSON.parse(atob(response));
        console.log(typeof responseData); 
      
       var resProductData = btoa(JSON.stringify(responseData.productData));
         localStorage.setItem("productData",resProductData);
        console.log("response minaj",responseData); // server response
       var get_product_id = responseData.productData.product_id;
       console.log("get_product_id",get_product_id);
                var get_product_handle = responseData.productData.product_handle;
                var get_variant_id = responseData.productData.variant_id;

                if(get_product_id != null  ){    
  					      
      				jQuery.getJSON('/cart.js', function(cart) {
 
                    	let items = cart.items;       	
                        var j=0;
                        for(var i=0; i < items.length; i++){
                          /*Match Local Storage Product ID with Cart Items */
                           if(items[i].product_id == get_product_id){ j =1;break;}
                        }
                        if(j == 0){
                          
                           var variant_id = get_variant_id;
                          var update = {};
                          update[variant_id] = 1;

                          jQuery.post('/cart/update.js', {
                            updates: update
                          }).always(function (e) {
                             

                          });

                        }
        				
  
					} ); /* ENDs JSON */
                }
      
        
      });
       

      
      
    }
    }
    
  }
}

